import {
    VuexModule,
    Module,
    Mutation,
    Action,
    getModule
} from "vuex-module-decorators";
import store from "@/store";
import lodash from "lodash";
import { getSchedulerInfo, getSchedulerJobList, getSchedulerJob, pauseSchedulerJob, resumeSchedulerJob, runSchedulerJob, modifySchedulerJob, addSchedulerJob, removeSchedulerJob } from '@/api/schedularService';

export interface SchedulerState {
    scheduler_info: {};
    jobs_list: [];
    loading: boolean;
}

@Module({store, dynamic: true, name: "schedulerModule"})
class SchedulerModule extends VuexModule implements SchedulerState {
    public scheduler_info:{} = {};
    public jobs_list:[] = [];
    public loading = false;

    @Action publicSetLoading(value) {
        this.setLoading(value);
    }

    @Action({ rawError: true }) async initialScheduler() {
        this.setLoading(true);
        this.setSchedulerInfo(await getSchedulerInfo());
        const result = await getSchedulerJobList();
        await result.forEach((element)=>{
            element['job_status'] = (element.next_run_time !== null)? "running":"stop";
        });
        this.setJobList(result);
        this.setLoading(false);
    }

    @Action({ rawError: true }) async pauseJob(job_id) {
        this.setLoading(true);
        await pauseSchedulerJob(job_id);
        this.setLoading(false);
        this.initialScheduler();
    }

    @Action({ rawError: true }) async resumeJob(job_id) {
        this.setLoading(true);
        await resumeSchedulerJob(job_id);
        this.setLoading(false);
        this.initialScheduler();
    }

    @Action({ rawError: true }) async runJob(job_id) {
        this.setLoading(true);
        await runSchedulerJob(job_id);
        this.setLoading(false);
        this.initialScheduler();
    }

    //Not using
    @Action({ rawError: true }) async modifyJob(job_id, editBody) {
        this.setLoading(true);
        await modifySchedulerJob(job_id, editBody);
        this.setLoading(false);
        this.initialScheduler();
    }

    //Not using
    @Action async addJob(editBody) {
        this.setLoading(true);
        await addSchedulerJob(editBody);
        this.setLoading(false);
        this.initialScheduler();
    }

    @Action({ rawError: true }) async removeJob(job_id) {
        this.setLoading(true);
        await removeSchedulerJob(job_id);
        this.setLoading(false);
        this.initialScheduler();
    }

    @Action({ rawError: true }) clearScheduler() {
        this.setJobList([]);
        this.setSchedulerInfo({});
    }

    @Mutation setLoading(loading: boolean): void {
        this.loading = loading;
    }

    @Mutation setSchedulerInfo(scheduler_info: {}):void {
        this.scheduler_info = scheduler_info;
    }

    @Mutation setJobList(jobs_list: []): void {
        this.jobs_list = lodash.cloneDeep(jobs_list);
    }
}

export const schedulerModule = getModule(SchedulerModule);